import axios from "axios";
import React, { Component,useEffect } from "react";
import { connect } from "react-redux";
import {
    set_datapage,
    getMapStateDefault,
  } from "@ora/recursos/src/redux/actions/DataPageAction";
import { baseUrl,localUrl } from "helpers/Url";
import qs from 'query-string'
import "css/reportes/scrollbar.css";
import $ from 'jquery'
import dt from 'datatables.net'
import {PageLength} from "helpers/Datatables";
import { findAllInRenderedTree } from "react-dom/test-utils";
import { buttonsAcciones, tagActivo } from "helpers/Datatables";
import Swal from "sweetalert2";
import { Helpers, Templates } from "@ora/recursos";
import { Link } from "react-router-dom";
const parametrosBusquedaLateral =
 {Tipo : "t" , Autores : "a", Año : "y", Formato : "f" }
 $.DataTable = dt

class LiDropdown extends Component {
    constructor (props){
        super(props)
        this.state = {
            isActive : false
        }

        this.handleActiveDropDown = this.handleActiveDropDown.bind(this)
        
    }

    handleActiveDropDown(){
        this.setState((state) =>({
            isActive : !state.isActive
        }))
    }

    llenarArraySublista(array, item, categoria){
        if(item[categoria] in array){
            array[item[categoria]] = array[item[categoria]] + 1
        }
        else{
            array[item[categoria]] = 1
        }
        return array
    }

    generarSublista(){
        let array = {}
        this.props.data.map((item)=>{
            switch (this.props.name) {
                case "Tipo":
                    array = this.llenarArraySublista(array, item, this.props.categoria)
                    break;
                case "Autores":
                    let strAutores = item[this.props.categoria].replace(/{/g, "").replace(/}/g, "").replace(/"/g, "")
                    let arrayAutores = strAutores.split(",")
                    arrayAutores.forEach(element => {
                        let itemAux = {}
                        itemAux[this.props.categoria] = element
                        array = this.llenarArraySublista(array, itemAux, this.props.categoria)
                       // console.log(array)
                    });
                    break;
                case "Año":
                    let index = item[this.props.categoria].indexOf("/")

                    if(index > 0){
                        item[this.props.categoria] = item[this.props.categoria].substring(0,index)
                    }

                    array = this.llenarArraySublista(array, item, this.props.categoria)
                    break;
                case "Formato":
                    array = this.llenarArraySublista(array, item, this.props.categoria)
                    break;
                default:
                    break;
            }
            
        })

      // console.log(array)

        let sublista = []

        Object.entries(array).forEach((element, index) => {

            // sublista[index] = <a className="dropdown-item" key={index} 
            // href={localUrl("/reportes/listadoc?"+parametrosBusquedaLateral[this.props.name]+"="+element[0].replace(/ /g, "-"))}>
            //     {element[0]} {" "} <div className="tag">{element[1]}</div>
            // </a>
            sublista[index] = <Link 
                className="dropdown-item" 
                key={index} 
                to={ localUrl("/reportes/listadoc?"+parametrosBusquedaLateral[this.props.name]+"="+element[0].replace(/ /g, "-"))}
                >
                {element[0]} {" "} <div className="tag">{element[1]}</div>
            </Link>
        });

        return sublista

    }



    render(){
        let className
        if(this.state.isActive){
            className = "dropdown is-active"
        }
        else{
            className = "dropdown"
        }

        return(
        <div className={className}>
        <div className="dropdown-trigger">
            <button className="button" aria-haspopup="true" aria-controls="dropdown-menu" onClick={this.handleActiveDropDown}>
            <span>{this.props.name}</span>
            <span className="icon is-small">
                <i className="fas fa-angle-down" aria-hidden="true"></i>
            </span>
            </button>
        </div>
        <div className="dropdown-menu" id="dropdown-menu" role="menu">
            <div className="dropdown-content">
            {this.generarSublista()}
            </div>
        </div>
    </div> )
         
   
    }
}



class ListaGeneral extends Component {
    
    constructor (props) {
        super(props)
        console.log('constructor')
        this.state = {
            lista: false,
            cites: false,
            iucn: false,
            paises: false,
            recursos: false,
            regpag:process.env.REG_PAG,
            total_documentos : 0,
            LIST_ABC : ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
            valorBusqueda: "",
            parametrosBusqueda : {t:"", p : "", tp : "", f : "", y:"",l:"",a:"" },
            refParametrosBusqueda: ''
          };
          this.handleBusqueda=this.handleBusqueda.bind(this)
          this.buscar_simples=this.buscar_simples.bind(this)
          
       
    }

    setDataPage = () => {
        this.props.set_datapage({ titulo: this.props.language('doc_basededatosdoc'),
            fe_itemselect:"home",//clave de item del menu frontend que se debe activar ,
            isbackend: false,
            hasHeroBar: true,
            hasBreadcrumb: false,
            breadcrumb:[]
        });
       
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        //console.log('ENLACES',prevProps.countDataPage, this.props.countDataPage)
        if (prevProps.history.location.search !== prevProps.location.search) {
            console.log('draw datatble')
            let params= qs.parse(this.props.location.search)
            this.cambiarParametrosBusqueda(params, () => {
                this.datatable.draw()
            })
        }
        if (100 === +this.props.countDataPage) {
          this.setDataPage()
        
        }
  
    }

    generarParametrosURL(inputArrayAux = {index:null, value : null}){
       
        let urlParams = ""
        let arrayParams = this.state.parametrosBusqueda
        
        //wtf a pasaojajaxd
        //awebo con map
        //a quedé


       
        
        
        Object.entries(arrayParams).forEach((element,index) => {


           if(inputArrayAux.index == element[0]){
            element[1] = inputArrayAux.value
           }

           if(element[1] != "")
            
            if(index != arrayParams.length - 1){
                urlParams += element[0]+"="+element[1]+"&"
            }
            else{
                urlParams += element[0]+"="+element[1]
            }
    
        });
        return urlParams
    }
    cambiarParametrosBusqueda(arrayParams, callback){

        Object.entries(arrayParams).forEach((element, index) => {

            //aeaaaaaaaaaxd
            if(element[0] != ""){
                let items = this.state.parametrosBusqueda
                items[element[0]] = element[1].replace(/-/g, " ");
               

                this.setState({parametrosBusqueda : items})
            }
           }) 
        
           this.setState({}, callback)
    }
    componentDidMount() {
        console.log('componentDidMount')
        this.setDataPage()
        let params= qs.parse(this.props.location.search)
        console.log('params', params)
        this.cambiarParametrosBusqueda(params)

        console.log('parametrosBusqueda', this.state.parametrosBusqueda, this.generarParametrosURL())
        // var url=baseUrl(`aro/documentos/listardocumento2?`+this.generarParametrosURL())
        var url=baseUrl(`aro/documentos/listardocumento2`)

       axios.get(url).then(res => {
            console.log(res.data)
            this.initpage(res.data);
       })

       //INIT DATATABLE
       this.initDataTable()
    }
    initDataTable = () => {
        this.configDT =  {
            data: [],
            dom: "<'columns'<'column is-full'<'table-container't>>><'columns'<'column'l><'column'p>>",
            // dom: "<'b-table'<'table-wrapper'<'table-container't>><'top level'<'level-left'l><'level-right'p>>",
            processing: true,
            pageLength:PageLength(),
            ajax: {
              url: baseUrl("aro/documentos/listardocumentos_datatable"),
              data: (d) => {
                // d.filter = this.filter
                console.log('this.state.parametrosBusqueda', this.state.parametrosBusqueda)
                return {
                    ...d,
                    ref: this.state.refParametrosBusqueda,
                    filter: this.state.parametrosBusqueda
                    
                }
              },
              beforeSend: function () {
                // OnCall(); // show wating animation
              },
              complete: (xhr, status) => {
                console.log(xhr, status)
              },
              error: function (xhr, error, thrown) {
                  console.log(thrown)
                // OnFinish()
                //alert(xhr.status);
                //alert(thrown);
                if (!['abort'].some(v => v === thrown)) {

                    Swal.fire({
                        title: thrown,
                        html: `
                         <p> Se encontró un error en el servidor, intente más tarde.</p>
                         <p>Mensaje: ${xhr.status} - ${error}</p>
                        `,
                        icon: 'error'
                    }).then(sr => {
                        
                      })
                }
                
              }
            },
            serverSide: true,
            order: [[0, "desc"]],
            createdRow: (r, d, i) => {
            //   new Vue().$mount(r.querySelector(".cell-options"));
            },
            columns: [
              { data: "duc_int_id", render: (d, t, r) => {
                return `
                <a target="_blank" href="${localUrl('/reportes/listadoc/' + d)}" style="border-bottom: 1px dotted black;">
                  ${d}
                </a>`
              } },
              { data: "duc_txt_title", render: (d, t, r) => {
                return `
                <a target="_blank" href="${localUrl('/reportes/listadoc/' + r.duc_int_id)}">
                  ${d}
                </a>`
              } },
              { data: "duc_txt_description", render: (d, t, r) => {
                  d = d ? d : ''
                  let showText =  d?.length > 47 ? d.substr(0, 47) + '...' : d
                  return `<span title="${d}">${showText}</span>`
              } },
              { data: "duc_txt_creator", render: (d, t, r) => {
                  return (d.replace(/{/g, "").replace(/}/g, "")).replace(/"/g, "").replace(/,/g, ", ")
                } },
              { data: "duc_txt_date" },
              { data: "duc_txt_file", render: (d, t, r) => {
                let format = r.duc_txt_format.split('/').pop()
                return `
                    <a target="_blank" href="${baseUrl('aro/documentos/files/' + d)}">
                        <img alt="" src="${baseUrl("imagen/") + (format ? format.toUpperCase() : 'NONE') + ".png"}"></img>
                    </a>`
              } },
            //   { data: "var_txt_name" },
              { data: 'pai_int_id', render: (d, t, r) => {
                return `<img alt="" src="${baseUrl("imagen/") + d + ".png"}"></img>`
              }}
            //   { data: "dar_int_id", render: buttonsAcciones({
            //     baseurl: localUrl('/config/especimenes/'),
            //     translateUrl: localUrl('/translate/especimenes/')
            //   })}
            ],
            drawCallback: (dcall) => {
                console.log('dcall', dcall)
                
                this.setState({                   
                    total_documentos: dcall.json.recordsFiltered,
                    isloadsearch: false
                })
                $('#dtListaGeneral_paginate a.previous').addClass("pagination-link pagination-previous");
                $('#dtListaGeneral_paginate a.next').addClass("pagination-link pagination-next");
                $('#dtListaGeneral_paginate a.next').addClass("pagination-link pagination-next");
                $('#dtListaGeneral_paginate span a.paginate_button.current').addClass("pagination-link is-current");
                $('#dtListaGeneral_paginate span a.paginate_button').addClass("pagination-link");
         
              }
        }
        this.table = $('#dtListaGeneral')
        
        this.datatable = this.table.DataTable(this.configDT)
          .on('click', '.btn-acciones', this.OnClick_acciones)
          .on('xhr.dt', (e, setting, json, xhr) => {
            // if (json.adicional)
            //   this.crearMenu(json.adicional)
            console.log('xhr', setting, json)
            this.setState({
              refParametrosBusqueda: json.lastFilter
            })
          })
          .on('preXhr.dt', (e, setting, json, xhr) => {
            // if (json.adicional)
            //   this.crearMenu(json.adicional)
            setting.jqXHR.abort()
            console.log('preeeeeeeeexhr', setting, json)
            
          })
    }
    OnClick_acciones = (evt) => {
        evt.preventDefault()
    }
    initpage(result){ 
        // this.creartabla(result.data)
        console.log(result.data)
        this.seccionPaises(result.dataPais)
        //console.log(result.);
        // this.actualizarTotal(result.data.length)
        this.seccionLetras(this.state.LIST_ABC)
        this.crearMenu(result.data)
        
    }
    buscar_simples = (e) => {
      e.preventDefault()
       console.log('buscar_simples', this.state.valorBusqueda)
        // this.cambiarParametrosBusqueda({t : this.state.valorBusqueda})
        
        this.setState({
          parametrosBusqueda: {
            ...this.state.parametrosBusqueda,
            t: this.state.valorBusqueda
          }
        }, () => {
          var url = localUrl("/reportes/listadoc?"+this.generarParametrosURL())
          console.log('aaaaaaaaaa', url)
          this.props.history.push(localUrl(url))  
        //   this.datatable.draw()
            if (this.props.history.location.search === this.props.location.search) {
                console.log('draw datatble')
                this.datatable.draw()
            }
        })
       
        
        
        

        //window.location.reload(true);    
    }
    handleBusqueda(e){
    //   console.log('handleBusqueda')
        const value=e.target.value.replace(/ /g, "-");
       this.setState({
        valorBusqueda: value
    })
    }
    actualizarTotal = (numDoc) =>{
        this.setState((state)=>({total_documentos: state.total_documentos + numDoc}));
    }
    
    crearMenu(data){

        const menu=
        <ul>
            <li  className="my-1 bordesth" >
                <LiDropdown categoria="var_txt_name" name="Tipo" data={data}></LiDropdown>
            </li>
            <li  className="my-1 bordesth">
                <LiDropdown categoria="duc_txt_creator" name="Autores" data={data}></LiDropdown>
            </li>
            <li  className="my-1 bordesth">
                <LiDropdown categoria="duc_txt_date" name="Año" data={data}></LiDropdown>
            </li>
            <li  className="my-1 bordesth">
                 <LiDropdown categoria="duc_txt_format" name="Formato" data={data}></LiDropdown>
            </li>
            </ul>
        this.setState({
            menu : menu
        })
    }

    creartabla(rows){

        const tabla = rows.map((item,index)=>{
            const autores=(item.duc_txt_creator.replace(/{/g, "").replace(/}/g, "")).replace(/"/g, "").replace(/,/g, ", ");
            
            return (<tr>
                <th >{index+1}</th>
                <th >{item.duc_txt_title}</th>
                <th >{item.duc_txt_description}</th>
                <th >{autores}</th>
                <th >{item.duc_txt_date}</th>
                {/* <th>{item.duc_txt_format}</th> */}
                <th ><a href={item.duc_txt_url}><img alt="" src={baseUrl("imagen/")+item.duc_txt_format+".png"}></img></a></th>
                <th ><img alt="" src={baseUrl("imagen/")+item.pai_int_id+".png"}></img></th>
                {/* <th>{item.pai_int_id}</th> */}
            </tr>)
        });
        this.setState({
            tabla : tabla
        })
    }

    seccionPaises(rows2){

        const tabla2 = rows2.map((item,index)=>{
           
            let paramsUrl = this.generarParametrosURL({index : "p", value: item.pai_int_id})
            return (<div >
                <div className="paisseccion">
                    <a href={localUrl("/reportes/listadoc?"+paramsUrl)}>
                        <img className="sizepais" alt="" pais={item.pai_int_id} src={baseUrl("imagen/")+item.pai_int_id+".png"}></img></a>
                    <div >
                    {item.pai_txt_name}
                    </div>  
                </div>

            </div>)
        });
        this.setState({
            tabla2 : tabla2
        })
    }
    seccionLetras(rows3){
        console.log(rows3)
        
        const tabla3 = rows3.map((item,index)=>{

            let paramsUrl = this.generarParametrosURL({index : "l", value: item[0]})
            return (<div >
                <div className="abc" >
                    <a href={localUrl("/reportes/listadoc?"+paramsUrl)}>{item[0]}</a>
                </div> &nbsp;     
            </div>)
        });
        this.setState({
            tabla3 : tabla3
        })
    }

    listaFormatos(){
        let arrayFiltro = {t:"Título", p : "País", tp : "Tipo", f : "Formato", y:"Año",l:"Letra",a:"Autores"  }
        
        let formato = []
        let estadoPB =  Object.entries(this.state.parametrosBusqueda)
        estadoPB.forEach((element , index)=> {
            if(element[1] != ""){
                formato[index] =  
                <a style={{ color: 'white',textDecoration:'none' }} href={localUrl("/reportes/listadoc?"+this.generarParametrosURL({index : element[0], value: ""}))} className="badge">
                    {arrayFiltro[element[0]]}&nbsp;
                    <i className="fa fa-times"></i>
                </a>
            }
            
        });

        return formato
    }

    render() {

        return (
            <Templates.Default.BasePageRoute2 localUrl={localUrl} dataPage={this.props.DataPage}>
            <div>
               <div className="columns is-desktop">
                    {/* <div className="column">
                        <aside className="menu">
                            <p className="menu-label is-capitalize">
                                { this.props.language('general') }
                            </p>
                            {this.state.menu}
                        </aside>
                    </div> */}
                    <div className="column is-12 ">
                    <section className="sectionx is-main-section pt-0">
                    <div className="card has-table">                  
                        <div className="notification is-card-toolbar">
                            <div className="level">
                                <div className="level">
                                    <div className="level-item">
                                        <div className="field is-horizontal">
                                          <form action="" onSubmit={ this.buscar_simples }>
                                            <div className="field-body">
                                                <div className="columns mb-2">
                                                    <div className="field mt-2 mr-2">
                                                            <label className="label">{ this.props.language('doc_nombredoc') }</label>
                                                    </div>
                                                    <div className="field mr-2">
                                                        <input className="input is-expanded" onChange={this.handleBusqueda} id="txt_ncc" size="50" type="text" placeholder=""></input>
                                                    </div>     
                                                    <div className="field">
                                                        <div className="control">
                                                            <button className="button grisbtn" type="submit" >{ this.props.language('deco_buscar') }</button>
                                                        </div>
                                                    </div> 
                                                </div>
                                                  
                                            </div>
                                          </form>
                                        </div>
                                    </div>
                                </div> 
                            </div>
                            
                            <div className="level">
                                 <div className="level">
                                    <div className="level-item"> 
                                        <div className="field is-horizontal">
                                                <div className="field-body">
                                                    <div className="field">
                                                        <div className="columns is-left">
                                                        <strong><label htmlFor="">{this.props.language('doc_busquerapida')}</label></strong>
                                                        </div>
                                                        <div className="columns is-centered mt-2">
                                                        {this.state.tabla3}
                                                        </div>
                                                        <div className="columns is-left mt-5">
                                                        <strong><label htmlFor="">{this.props.language('doc_busquerapidapais')}</label></strong>
                                                        </div>
                                                        <div className="columns is-centered">
                                                        {this.state.tabla2}
                                                        </div> 
                                                        {/* <div className="columns is-centered">
                                                        <label htmlFor="">Filtros:&nbsp;</label>
                                                        <div >
                                                           {this.listaFormatos()}
                                                            
                                                        </div>
                                                        </div>  */}
                                                    </div>       
                                                </div>
                                                
                                            </div>    
                                    </div>
                                    
                                </div>
                                
                            </div>
                            
                        </div>
                        <div className="columns is-centered">
                            <div className="">
                                <div className="mx-5">
                                    <label htmlFor="" >{this.props.language('doc_filtros')}&nbsp;</label>
                                    {this.listaFormatos()}
                                </div>
                            </div>
                            
                        </div> 
                        <font size="3"><h1 className="tamano">{this.props.language('doc_total')} {this.state.total_documentos}</h1></font>
                        
                        <div className="card">
                            <div className="column">
                                <div className="columns is-desktop has-text-left">
                                    <table id="dtListaGeneral" className="table is-fullwidth is-striped is-hoverable is-fullwidth">
                                        <thead >
                                            <tr >
                                                <th >#</th>
                                                <th >{this.props.language('doc_titulo')}</th>
                                                <th >{this.props.language('doc_descripcion')}</th>
                                                <th >{this.props.language('doc_autores')}</th>
                                                <th>{this.props.language('deco_year')}</th>
                                                <th >{this.props.language('doc_formato')}</th>
                                                <th >{this.props.language('deco_pais')}</th>
                                            </tr>
                                        </thead>
                                        <tbody >
                                        {this.state.tabla}
                                        </tbody>
                                    </table>
                                </div>  
                            </div>
                        </div>
                    </div>
                </section>
                    
                    </div>
                </div>
                

            </div>
            </Templates.Default.BasePageRoute2>
        )
    }
}


// export default connect(getLanguage, {set_datapage, SetLanguage})(ListaGeneral)
export default connect(getMapStateDefault(), {
    set_datapage,
    // seDatatDocumentos,
    // setEstandarData,
    // checkEstandarData,
    // checkDataDirectorio,
  })(ListaGeneral);